import {
	autoinject,
	bindable,
	customElement,
	inlineView,
} from 'aurelia-framework';
import * as React from 'react';

import { ProgressBar as OUIProgressBar } from '~/lib/oui/components/ProgressBar/ProgressBar';
import { ThemeColor } from '~/lib/oui/types/prop.types';
import { ReactComponent } from '~/components/react-component/react-component';
import { Logger } from '~/utils/logger';

@autoinject
@customElement('a-progress-bar')
@inlineView('<template ref="refContainer"></template>')
export class ProgressBar extends ReactComponent {
	public static readonly ThemeColor = ThemeColor;

	/**
	 * Enable animation
	 * @default false
	 */
	@bindable
	public animated: boolean = false;

	/**
	 * Class names
	 */
	public className?: string;

	/**
	 * Theme color
	 * @default ThemeColor.Primary
	 */
	@bindable
	public color: ThemeColor = ThemeColor.Primary;

	/**
	 * Label to display on the progress bar
	 */
	@bindable
	public label?: string;

	/**
	 * The maximum value of the progress bar
	 * @default 100
	 */
	@bindable
	public maxValue: number = 100;

	/**
	 * The minimum value of the progress bar
	 * @default 0
	 */
	@bindable
	public minValue: number = 0;

	/**
	 * The current value of the progress bar
	 * @default 0
	 */
	@bindable
	public nowValue: number = 0;

	/**
	 * Applies a striped CSS gradient over the progress bar
	 * @default false
	 */
	@bindable
	public striped: boolean = false;

	constructor(protected element: Element) {
		super('a-progress-bar', element);
	}

	/**
	 * getHTML will get the HTML for the React component.
	 * Expects render() to be called first.
	 *
	 * @deprecated This is a hack and should be avoided
	 */
	public getHTML(): string {
		const container = this.getRefContainer();
		if (!container) {
			Logger.warn(
				'getHTML returned empty string as the React container element disappeared unexpectedly. This should never happen.',
			);
			return '';
		}
		return container.outerHTML;
	}

	/**
	 * Render the React DOM
	 */
	public render() {
		this.renderReactDOM(
			<OUIProgressBar
				animated={this.animated}
				className={this.className}
				color={this.color}
				label={this.label}
				max={this.maxValue}
				min={this.minValue}
				now={this.nowValue}
				striped={this.striped}
			/>,
		);
	}
}
